"use client";

type PremiumLoaderProps = {
  progress: number;
};

export default function PremiumLoader({ progress }: PremiumLoaderProps) {
  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-[radial-gradient(900px_circle_at_50%_-20%,rgba(201,168,76,0.2),transparent_60%),linear-gradient(180deg,#120f09_0%,#0f0c08_100%)]"
      aria-live="polite"
      aria-label="Loading portfolio"
    >
      <div className="w-full max-w-md px-8 text-center">
        <p className="text-xs uppercase tracking-[0.35em] text-primary/80">
          Portfolio
        </p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-foreground">
          Md Sakibul Islam
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Preparing premium experience
        </p>

        <div className="mt-8 h-2 w-full overflow-hidden rounded-full bg-white/10">
          <div
            className="h-full rounded-full bg-[linear-gradient(90deg,rgba(201,168,76,0.95),rgba(255,255,255,0.95))] transition-[width] duration-200 ease-out"
            style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
          />
        </div>
        <p className="mt-3 text-xs font-medium tabular-nums text-primary/90">
          {Math.round(progress)}%
        </p>
      </div>
    </div>
  );
}
